'use client'
import React from 'react'
import { PageLayoutWidth } from '../PageLayout'

type FullWidthLayoutProps = {
    width: PageLayoutWidth
    children: React.ReactNode
}

export const FullWidthLayout = ({ children, width }: FullWidthLayoutProps) => {
    return <main className={`app-content spacing-page-x grow flex flex-col mx-auto ${width}`}>{children}</main>
}
